var App = App || {};

App.Panels = (function ($) {
    "use strict";

    function init() {
        $(document).ready(function () {
            if (window.location.hash != "") {
                openPanelAndScroll($(window.location.hash));
            }
        });

        $('a').on("click", function () {
            if ($(this).attr("href").indexOf('#') == 0)
            {
                openPanelAndScroll($($(this).attr("href")));
            }
        });
    }

    function openPanelAndScroll(jumpTarget) {
        if (jumpTarget.length > 0) {
            if (jumpTarget.parents(".scrollable-panel").length > 0) {
                var targetHeading = $("#" + jumpTarget.parents(".scrollable-panel").attr("data-heading"));
                if (targetHeading.hasClass("accordion-button")) {
                    if (targetHeading.hasClass("collapsed")) {
                        targetHeading.click();
                    }
                } else {
                    targetHeading.click();
                }
                $([document.documentElement, document.body]).stop().animate({
                    scrollTop: jumpTarget.offset().top
                }, 1);
            }
            else if (jumpTarget.attr("data-bs-toggle") == "tab" || jumpTarget.attr("data-bs-toggle")) {
                if (jumpTarget.hasClass("accordion-button")) {
                    if (jumpTarget.hasClass("collapsed")) {
                        jumpTarget.click();
                    }
                } else {
                    jumpTarget.click();
                }
            }
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Panels.init();
});